<template>
  <div class="logo-container">
    <svg :viewBox="'-2 -2 ' + (w+4) + ' ' + (h+4)" :width="(w+4)" :height="(h+4)" class="logo" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <!-- <rect x="0" y="0" :width="w" :height="h" style="fill:none;stroke:orange;stroke-width:1;opacity:1" /> -->
    <defs>
      <filter id="dropshadow">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2"></feGaussianBlur>
          <feOffset dx="2" dy="2" result="offsetblur"></feOffset>
          <feMerge>
              <feMergeNode></feMergeNode>
              <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
      </filter>
     </defs>
      <g>
        <g filter="url(#dropshadow)" :transform="'translate(' + xArrow + ', ' + yArrow  + ') rotate(' + rArrow + ', 123, 94)'">
          <path :d="'M0,'+(h*0.385)+' L'+(w - h*0.14)+','+(h*0.015)+' A'+(h*0.04)+','+(h*0.04)+' 0 0 1 '+ (w-h*0.1) +','+(h*0.015)+' L'+(w - h*0.02)+','+(h*0.12)+' A'+(h*0.04)+','+(h*0.04)+' 0 0 1 '+ (w-h*0.02) +','+(h*0.17)+' L0,'+(h*0.615)+' Z'" :fill="colors[1]" />
        </g>
        <g filter="url(#dropshadow)" :transform="'translate(' + xBar + ', ' + yBar + ') rotate(' + rBar + ', 15, 85)'">
          <rect :x="h*0.02" :y="h*0.01" :width="h*0.18" :height="h*0.98" :rx="h*0.04" :ry="h*0.04" fill="#607d8b" />
        </g>
        <g filter="url(#dropshadow)" :transform="'translate(' + xArrow + ', ' + yArrow  + ') rotate(' + rArrow + ', 123, 94)'">
          <path :d="'M0,'+(h*0.385)+' L'+ (w-h*0.02) +','+(h*0.84)+' A'+(h*0.04)+','+(h*0.04)+' 0 0 1 '+(w - h*0.02)+','+(h*0.89)+' L'+ (w-h*0.1) +','+(h*0.985)+' A'+(h*0.04)+','+(h*0.04)+' 0 0 1 '+(w - h*0.14)+','+(h*0.985)+' L0,'+(h*0.615)+' Z'" :fill="colors[0]" />
        </g>
      </g>
    </svg>
  </div>
</template>

<style>
  .logo-container {
    overflow: hidden;
  }

  .logo-container svg.logo{
    margin-top:5%;
    height:90%;
    width:auto;
  }
</style>

<script>

module.exports = {
  name: 'logo',
  props: ['colors'],
  data: function() {
    return {
      w: 118,
      h: 192,
      rArrow: 0,
      xArrow: 0,
      yArrow: 0,
      xBar: 0,
      yBar: 0,
      rBar: 0
    }
  }
}

</script>



// WEBPACK FOOTER //
// Logo.vue?6ea5c45e